import React, { useState, useEffect } from 'react';
import axios from 'axios';
import 'bootstrap/dist/css/bootstrap.min.css';
import { API_URL, ENDPOINTS } from '../../constants/api';
import { decodeToken, getToken } from '../../utils/TokenUtils';
import { CURRENT_DATE } from '../../constants';
import { useNavigate } from 'react-router-dom';

const ElectionPage = () => {
  const [candidates, setCandidates] = useState([]);
  const navigate = useNavigate();

  const [votes, setVotes] = useState({});
  const [loading, setLoading] = useState(true);
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState(null);
  const [successMsg, setSuccessMsg] = useState('');
  const [errorMsg, setErrorMsg] = useState('');
  const [counter, setCounter] = useState(5);

  const token = getToken();
  const voterId = decodeToken(token, 'id');
  const branchId = decodeToken(token, 'branch_id');
  const loginPage = decodeToken(token, 'loginPage');

  useEffect(() => {
    // Fetch candidates from API
    const fetchCandidates = async () => {
      try {
        const res = await axios.get(
          `${API_URL}/${ENDPOINTS.SYS}/getlink/candidates-to-vote`,
          {
            headers: {
              Authorization: token ? `Bearer ${token}` : '',
            },
          }
        );
        console.log('res.data:', res.data);
        setCandidates(res.data.report);
        setLoading(false);
      } catch (err) {
        setError('Failed to load candidates.');
        setLoading(false);
      }
    };

    fetchCandidates();
  }, []);

  const groupedCandidates = candidates.reduce((acc, candidate) => {
    acc[candidate.title] = acc[candidate.title] || [];
    acc[candidate.title].push(candidate);
    return acc;
  }, {});

  const handleVote = (title, candidate) => {
    setVotes((prev) => ({
      ...prev,
      [title]: {
        election_id: candidate.election_id,
        candidate_id: candidate.id,
        election_title_id: candidate.election_title_id,
      },
    }));
  };

  console.log('votes:', votes);
  const handleSubmit = async () => {
    const submissions = Object.entries(votes).map(([title, voteData]) => ({
      branch_id: branchId,
      election_id: voteData.election_id,

      voter_id: voterId,

      election_title_id: voteData.election_title_id,
      candidate_id: voteData.candidate_id,
      date: CURRENT_DATE,
    }));

    try {
      setSubmitting(true);
      setError(null);
      setSuccessMsg(null);

      const responses = await Promise.all(
        submissions.map((vote) =>
          axios.post(
            `${API_URL}/${ENDPOINTS.SYS}/create/register-ele_vote`,
            vote,
            {
              headers: {
                Authorization: token ? `Bearer ${token}` : '',
              },
            }
          )
        )
      );
      // Combine and display messages from responses

      const hasError = responses.some(
        (res) => res.data.success === 0 || res.data.success === '0'
      );

      const responseMessages = responses
        .map((res, i) => `Cod-ka ${i + 1}aad: ${res.data.message || 'Success'}`)
        .join('\n');

      if (hasError) {
        setErrorMsg(`Cillad :\n${responseMessages}`);
      } else {
        setSuccessMsg(`Waad codeysay !\n${responseMessages}`);
      }

      // Start countdown
      const intervalId = setInterval(() => {
        setCounter((prev) => {
          if (prev === 1) {
            clearInterval(intervalId);
            // Remove token from localStorage
            localStorage.removeItem('authToken');
            navigate('/login/' + loginPage); // <-- change to your redirect path
            return 0;
          }
          return prev - 1;
        });
      }, 1000);

      return () => clearInterval(intervalId); // cleanup on unmount
    } catch (err) {
      setError('Failed to submit all votes.');
    } finally {
      setSubmitting(false);
    }
  };

  const isSubmitDisabled =
    Object.keys(groupedCandidates).length !== Object.keys(votes).length ||
    submitting ||
    errorMsg !== '' ||
    successMsg !== '';

  if (loading)
    return <div className="text-center mt-5">Loading candidates...</div>;
  if (error) return <div className="text-danger text-center mt-5">{error}</div>;

  return (
    <div className="mt-5" style={{ width: '95%', margin: 'auto' }}>
      <div className="">
        <div className="row">
          {Object.entries(groupedCandidates).map(([title, titleCandidates]) => {
            return (
              <div key={title} className="row">
                <div className="col-12">
                  <h2 className="mb-4 text-center">
                    <strong>{title}</strong>
                  </h2>
                </div>

                {titleCandidates.map((candidate) => (
                  <div key={candidate.id} className="col-md-2 mb-4">
                    <div className="card shadow-sm h-100">
                      <center>
                        <img
                          src={`${API_URL}/${candidate.image}`}
                          className="card-img-top"
                          alt={candidate.name}
                          style={{
                            width: '250px',
                            height: '250px',
                            objectPosition: 'center',
                            display: 'block',
                          }}
                        />
                      </center>
                      <div className="card-body text-center">
                        <h5 className="card-title">{candidate.name}</h5>
                      </div>
                      <div className="card-footer text-center">
                        <div className="form-check d-flex justify-content-center align-items-center gap-2">
                          <input
                            className="form-check-input"
                            type="radio"
                            name={title}
                            id={`vote-${candidate.id}`}
                            checked={
                              votes[title]?.candidate_id === candidate.id
                            }
                            onChange={() => handleVote(title, candidate)}
                            style={{
                              transform: 'scale(1.5)',
                              cursor: 'pointer',
                            }}
                          />
                          <label
                            className="form-check-label fw-bold fs-5"
                            htmlFor={`vote-${candidate.id}`}
                          >
                            Vote
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            );
          })}
        </div>
      </div>

      {successMsg && (
        <>
          <p>
            Redirecting in {counter} second{counter !== 1 ? 's' : ''}...
          </p>
          <div className="alert alert-success text-center">{successMsg}</div>
        </>
      )}

      {errorMsg && (
        <>
          <h3 className=" text-center">
            Redirecting in <strong>{counter}</strong> second
            {counter !== 1 ? 's' : ''}...
          </h3>
          <div className="alert alert-danger text-center">{errorMsg}</div>
        </>
      )}

      <div className="text-center">
        <button
          className="btn btn-primary btn-lg fw-bold w-100 mt-4"
          disabled={isSubmitDisabled}
          onClick={handleSubmit}
        >
          {submitting ? 'Submitting...' : 'Submit Votes'}
        </button>
        <br />
        <br />
      </div>
    </div>
  );
};

export default ElectionPage;
